import { useState, useEffect } from "react";

const BREAKPOINTS = {
  xl: 1280,
  lg: 1024,
  md: 768,
} as const;

function getGroupSize(width: number): number {
  if (width >= BREAKPOINTS.xl) return 4;
  if (width >= BREAKPOINTS.lg) return 3;
  if (width >= BREAKPOINTS.md) return 2;
  return 1;
}

export function useResponsiveGroupSize(): number {
  const [groupSize, setGroupSize] = useState(1);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    const updateGroupSize = () => {
      setGroupSize(getGroupSize(window.innerWidth));
    };

    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(updateGroupSize, 100);
    };

    updateGroupSize();
    window.addEventListener("resize", handleResize);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return groupSize;
}

export function groupSections<T>(sections: T[], groupSize: number): T[][] {
  const grouped: T[][] = [];
  for (let i = 0; i < sections.length; i += groupSize) {
    grouped.push(sections.slice(i, i + groupSize));
  }
  return grouped;
}
